import * as React from 'react';
import { ErrorBoundary } from "@appsignal/react";
import IErrorPage, { TErrorPage } from './IErrorPage';
import { appsignal } from "./../../appsignal";
import * as style from './ErrorPageStyle.module.scss'

export default class ErrorPage extends React.Component<IErrorPage, TErrorPage> {
  state:TErrorPage = {
    returnUrl:'',
    hasHistory: false,
  };

  componentDidMount() {
    this.setState({ returnUrl: window.location.search });
    if (this.props.history) {
      this.setState({ hasHistory: true });
    }
  }

  render() {
    const { errorCode } = this.props.match ? this.props.match.params : this.props;
    return (
      <ErrorBoundary instance={appsignal}>
        <div className={style.errorPage}>
          <div className={style.errorContent}>
            <h1 className={style.errorCode}>{errorCode}</h1>
            <span className={style.errorMessage}>
              {this.getErrorForCode(errorCode)}
            </span>
          </div>
        </div>
      </ErrorBoundary>
    );
  }

  private getErrorForCode(errorCode: string) {
    let message;
    switch (errorCode){
      case '401':
        message = (
          <React.Fragment>
            <span>
              You are unauthorized, please &nbsp;
            </span>
            <a className={style.link} href={`/users/sign_in${this.state.returnUrl}`}>
              Sign in
            </a>
            <span>
              &nbsp; to see this page.
            </span>
          </React.Fragment>
        );
        break;
      case '403':
        message = (
          <React.Fragment>
            <div>
              You are unauthorized to view this page.
            </div>
            {this.renderBackButton()}
          </React.Fragment>
        );
        break;
      case '404':
        message = (
          <React.Fragment>
            <div>
              We couldn't find the page you're looking for.
            </div>
            {this.renderBackButton()}
          </React.Fragment>
        );
        break;
      case '424':
        message = (
          <React.Fragment>
            <div>
              External service is temporarily unavailable. Try again later.
            </div>
            {this.renderBackButton()}
          </React.Fragment>
        );
        break;
      case 'Deposit Maintenance':
        message = (
          <React.Fragment>
            <div>
              Dear valued customers,<br/><br/>
              We would like to inform you that our deposit system is currently undergoing essential upgrades to enhance our services. As a result, deposit services are temporarily suspended during this period.<br/><br/>
              We apologize for any inconvenience this may cause and appreciate your understanding as we work to improve our systems.<br/><br/>
              We anticipate that the upgrade process will be completed soon, and normal deposit services will resume promptly. We appreciate your patience and cooperation during this maintenance period.<br/><br/>
              Thank you for your continued trust and loyalty.<br/><br/>
            </div>
          </React.Fragment>
        );
        break;
      default:
        message = (
          <React.Fragment>
            <div>
              There was an unexpected error. Our developement team was notified.
            </div>
            <span>
              Please &nbsp;
            </span>
            <a className={style.link} href={`/`}>
              Return to homepage
            </a>
          </React.Fragment>
        );
    }
    return (
      <React.Fragment>
        <h2>
          Sorry!
        </h2>
        <span>
          {message}
        </span>
      </React.Fragment>
    );
  }

  private renderBackButton() {
    return window.history.length > 2 &&
      (
        <button className={style.btn} onClick={() => this.goBack()}>
          Go Back
        </button>
      );
  }

  private goBack() {
    if (this.state.hasHistory) {
      this.props.history.go(-2);
    } else {
      window.history.go(-2);
      window.location.reload();
    }
  }
}
